module.exports = __webpack_public_path__ + "static/media/unicorn.7afda514.svg";